module.exports = __webpack_public_path__ + "img/Cauliflower.f93bf74a.svg";